import { ForwardedRef, HTMLAttributes, ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface DropdownMenuProps extends HTMLAttributes<HTMLUListElement> {
  isOpen?: boolean;
  children?: ReactNode;
  ref?: ForwardedRef<HTMLUListElement>;
}

const DropdownMenu = styled.ul<DropdownMenuProps>`
  border: ${({ theme }) => `1px solid ${theme.palette.borderColor}`};
  background-color: ${({ theme }) => theme.palette.backgrounds.main};
  border-radius: 0;
  padding: 0;
  position: absolute;
  top: 29px;
  left: 8px;
  z-index: 1000;
  min-width: 160px;
  font-size: 1em;
  text-align: left;
  list-style: none;

  ${({ isOpen }) =>
    !isOpen &&
    css`
      display: none;
    `};
`;

export default DropdownMenu;
